<template>
    <u-tit-default v-bind="$attrs" class="tit--sm"><slot /></u-tit-default>
</template>

<script>
import UTitDefault from "@/components/publish/styles/typography/u-tit-default.vue";

export default {
    props: {},
    components: {
        UTitDefault,
    },
    data: () => {
        return {};
    },
    mounted() {},
    methods: {},
};
</script>

<style lang="scss" scoped></style>
